import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { IConfig } from "./interfaces";
import { YOUM_API_CONFIG_TOKEN } from "./youm-api.token";
import { YoumAPIFacade } from "./youm-api.facade";

@NgModule({
  imports: [CommonModule]
})
export class YoumAPIModule {
  static forRoot(config: IConfig): ModuleWithProviders<YoumAPIModule> {
    return {
      ngModule: YoumAPIModule,
      providers: [
        YoumAPIFacade,
        {
          provide: YOUM_API_CONFIG_TOKEN,
          useValue: config
        }
      ]
    };
  }
}
